import { FeatureFlag } from "us.common/FeatureFlagContext/Interfaces";

export enum FeatureFlags {
  MERGE_DEBTOR = "MergeDebtor",
  NON_PRODUCTION_DAYS = "NonProductionDays",
  OPERATIONS = "OperationsModule",
}

export const DEFAULT_FEATURE_FLAGS: Array<FeatureFlag> = [
  {
    featureName: FeatureFlags.MERGE_DEBTOR,
    isEnabled: false,
  },
  {
    featureName: FeatureFlags.NON_PRODUCTION_DAYS,
    isEnabled: false,
  },
  {
    featureName: FeatureFlags.OPERATIONS,
    isEnabled: false,
  },
];
